import { Produto } from '../protocols';
import { escapeHtml } from './escapeHtml';
import { getIbsCbsSubtitle } from './getIbsCbsWarningTitle';

const buildIbsCbsTableHtml = (itens: Produto[]): string => {
  const header = `
    <tr>
      <th style="text-align:left;padding:8px;">Item</th>
      <th style="text-align:left;padding:8px;">Código</th>
      <th style="text-align:left;padding:8px;">Descrição</th>
    </tr>
  `;

  const body = itens
    .map((p, idx) => {
      const index = (p as any)?.num_item ?? idx + 1;
      const codigo = (p as any)?.cod_produto ?? '';
      const descricao = escapeHtml((p as any)?.des_produto ?? '');
      return `
        <tr>
          <td style="text-align:left;padding:8px;">${index}</td>
          <td style="text-align:left;padding:8px;">${codigo}</td>
          <td style="text-align:left;padding:8px;">${descricao}</td>
        </tr>
      `;
    })
    .join('');

  return `
    <div style="max-height:260px;border:1px solid #dcdcdc;overflow:auto;">
      <table style="width:100%;min-width:600px;border-collapse:collapse;">
        <thead>${header}</thead>
        <tbody>${body}</tbody>
      </table>
    </div>
  `;
};

export const buildIbsCbsHtmlContent = (itens: Produto[]): string => {
  const subtitle = getIbsCbsSubtitle();
  const subtitleHtml = subtitle
    ? `<p style="margin:0 0 10px 0;font-size:0.95rem;color:#555;">${escapeHtml(
        subtitle,
      )}</p>`
    : '';
  return `${subtitleHtml}${buildIbsCbsTableHtml(itens)}`;
};
